const publicationStatusAvailables = [
  { label: 'Publicado', keyword: 'PUBLICADO', color: 'success' },
  { label: 'Ponencia', keyword: 'PONENCIA', color: 'primary' },
  { label: 'Prepints', keyword: 'PREPRINTS', color: 'warning' },
];

export default publicationStatusAvailables;
